import React from "react";
import { useParams } from "react-router-dom";
import NotFoundPage from "@/components/layouts/NotFoundPage";
import { useFeatureFlag } from "@/services/features/hook";
import { FeatureFlags } from "@/services/features/types";
import { ProductsAndServicesSettings } from "./ProductsAndServicesSettings";
import { ProductListPage } from "./ProductListPage";
import { ProductPage } from "./ProductPage";

export const ProductsSettings: React.FC = () => {
  const { productId } = useParams();
  const { enabled, loading } = useFeatureFlag(
    FeatureFlags.CRM_11089_PRODUCT_BUNDLES
  );

  // Waiting avoids flashing the other layout while the flag resolves.
  if (loading) return null;

  if (!enabled) {
    return productId ? (
      <NotFoundPage data-test="product-page-404" />
    ) : (
      <ProductsAndServicesSettings />
    );
  }

  // Keyed so a dragged order on one product can't show on the next.
  return productId ? <ProductPage key={productId} /> : <ProductListPage />;
};
